/* eslint-disable  */

import React from 'react';
import { createContext, useState, } from 'react';
export const MenuContext = createContext<any>('');
export function MenuContextProvider(props: any) {
  const [enableLanguageDropdown, setEnableLanguageDropdown] = useState(false);
  const [dateTimeLocalization, setDateTimeLocalization] = useState(false);
  const isToggle = window.sessionStorage.getItem('language') == 'es-US' || window.sessionStorage.getItem('language') == 'es-MX' ? true : false
  const [toggleSpanish, setToggleSpanish] = useState(isToggle)
  const [storeDetails, setStoreDetails] = useState()
  const [selectedLang, setSelectedLang] = useState('');




  return (
    <div>
      <MenuContext.Provider
        value={{
          enableLanguageDropdown, setEnableLanguageDropdown,
          toggleSpanish, setToggleSpanish,
          storeDetails, setStoreDetails,
          selectedLang, setSelectedLang,
          dateTimeLocalization, setDateTimeLocalization
        }}
      >
        {props.children}
      </MenuContext.Provider>
    </div>
  );
}
